import { FunctionComponent, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import './App.css'

import PublicRoutes from 'public-routes'
import Layout from 'components/layout/layout'
import { isAuthenticated, logout } from './features/user/auth'

const App: FunctionComponent = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated())
  const isExternalAuthRoute = location.pathname === '/external-auth'

  const handleSuccessfulLogin = () => {
    setIsLoggedIn(isAuthenticated())
    navigate('/')
  }

  const handleLogout = () => {
    logout()
    setIsLoggedIn(isAuthenticated())
    navigate('/login?logout=true')
  }

  // External auth must run even when a session already exists, otherwise
  // PrivateRoutes has no match for /external-auth and the app stays blank.
  return isLoggedIn && !isExternalAuthRoute ? (
    <Layout handleLogout={handleLogout} />
  ) : (
    <PublicRoutes handleSuccessfulLogin={handleSuccessfulLogin} />
  )
}

export default App
